import { Flex } from "@chakra-ui/react";

import { useNamespace } from "~/hooks";

import { Phrase, Subtitle } from "..";

function Talks() {
  const { translate } = useNamespace("outdoor");

  return (
    <Flex direction="column" gap={["2", "4"]} mt={["0", "4.375rem"]} align={"start"} textAlign={["center", "left"]}>
      <Phrase fontSize={["1.25rem", "3rem"]} lineHeight={["24px", "56px"]}>
        {translate("outdoor@signUp-Talks-one")}
      </Phrase>
      <Subtitle>{translate("outdoor@signUp-Talks-two")}</Subtitle>
    </Flex>
  );
}

export default Talks;
